"use client";

import { ErrorScreen } from "@/components/error-screen";

// Boundary for the whole (console) group — errors keep the sidebar frame.
export default function ConsoleError({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  return <ErrorScreen error={error} retry={retry} />;
}
